import classNames from 'classnames'
import React from 'react'
import Tab from './Tab'
import styles from './styles.module.scss'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { useLocation } from 'react-router'

type TabInfo = {
  icon: IconDefinition
  location: string
  tip: string
  external?: boolean
}

type Props = {
  className?: string
  tabs?: TabInfo[]
}

export const ExternalLinkBar: React.FC<Props> = ({ className, tabs }) => {
  const location = useLocation()
  return (
    <div className={classNames(styles.container, className)}>
      {tabs?.map((tab, i) => (
        <Tab external={tab.external === undefined ? true : tab.external} key={`TAB_${i}`} {...tab} selected={tab.location === location.pathname} />
      ))}
    </div>
  )
}
